import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getPatientLab(patientId, type) {
        return Axios.get(`${baseURL}lab/patient`, {
            params: { id: patientId, type }
        }).then(response => response.data.response);
    },
    savePatientLab(formData) {
        return Axios.post(
            `${baseURLci}patient/patient/save_patient_lab`,
            formData
        ).then(response => response.data);
    },
    getRecordZoetisFuse(recordId, patientId) {
        return Axios.get(`${baseURLci}patient/patient/record_zoetis_fuse`, {
            params: { id: recordId, pid: patientId }
        }).then(response => response.data);
    },
    getRecordAbaxis(recordId, patientId) {
        return Axios.get(`${baseURLci}patient/patient/record_abaxis`, {
            params: { id: recordId, pid: patientId }
        }).then(response => response.data);
    },
    savePatientLabResult(formData) {
        return Axios.post(
            `${baseURLci}patient/patient/save_patient_lab_result`,
            formData
        ).then(response => response.data);
    },
    getRecords(recordId, patientId, source) {
        return Axios.get(`${baseURLci}patient/patient/find_records`, {
            params: { id: recordId, pid: patientId, source }
        }).then(response => response.data);
    },
    saveUnassignedLabResult(formData) {
        return Axios.post(
            `${baseURLci}patient/patient/save_unassigned_lab_result`,
            formData
        ).then(response => response.data);
    },
    getRecordAntech(recordId, patientId) {
        return Axios.get(`${baseURLci}patient/patient/record_antech`, {
            params: { id: recordId, pid: patientId }
        }).then(response => response.data);
    },
    savePatientAntech(formData) {
        return Axios.post(
            `${baseURLci}patient/patient/save_patient_antech`,
            formData
        ).then(response => response.data);
    },
    getAddDialogDetails(params) {
        return Axios.get(`${baseURLci}patient/lab/add_dialog`, {
            params
        }).then(response => response.data);
    },
    getSourceStatus(params) {
        return Axios.get(`${baseURLci}patient/lab/source_status`, {
            params
        }).then(response => response.data);
    },
    getResults(source, id) {
        return Axios.get(
            `${baseURL}lab/unassign-lab/preview/result/${source}/${id}`
        ).then(response => response.data);
    },
    getAntechOrderStatus(id) {
        return Axios.get(`${baseURL}lab/antech/v6/order/status/${id}`).then(
            response => response.data.response
        );
    }
};
